export default "__VITE_ASSET__D_$tGirA__"